import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { ControlService, IconService, ScheduleService, SubtitlesService } from "../../../core";
import { MenuElement, MenuType } from "../../../models";

@Component({
    selector: 'schedule-on-off',
    templateUrl: './schedule-on-off.component.html',
    styleUrls: ['./schedule-on-off.component.scss']
})
export class ScheduleOnOffComponent implements AfterViewInit, OnInit, OnDestroy {
    protected Array = Array;

    private dragging = false;
    private pointerId: number | null = null;
    private moved = false;
    private removeListeners: (() => void) | null = null;

    constructor(
        public control: ControlService,
        private icon: IconService,
        public schedule: ScheduleService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngOnInit() {
        this.schedule.onOffGetSet('main');
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    ngOnDestroy() {
        this.cleanup();
    }

    onPointerDown(e: PointerEvent, val: boolean, idx: number) {
        if (e.button !== 0 && e.pointerType !== 'touch') return;
        e.preventDefault();

        this.dragging = true;
        this.pointerId = e.pointerId;
        this.moved = false;

        this.schedule.onOffSetStartVal(val);
        this.setupMove();
    }

    onPointerCancel() {
        this.cleanup();
    }

    onPointerUp(e: PointerEvent, idx: number) {
        if (!this.dragging || this.pointerId !== e.pointerId) return;
        if (!this.moved && idx > 0) {
            this.schedule.onOffToggleHourByIndex(idx);
        }
        this.cleanup();
    }

    private setupMove() {
        if (this.removeListeners) return;

        const move = (e: PointerEvent) => {
            if (!this.dragging || e.pointerId !== this.pointerId) return;
            this.moved = true;

            const el = document.elementFromPoint(e.clientX, e.clientY);
            const hour = el?.closest('.on-off__select-hour');
            const id = hour?.getAttribute('data-testid');
            if (!id?.startsWith('onOffHour-')) return;

            const idx = parseInt(id.slice(10), 10);
            if (idx > 0) this.schedule.onOffToggleHourByIndex(idx);
        };

        const up = () => this.cleanup();

        document.addEventListener('pointermove', move as EventListener, { passive: false });
        document.addEventListener('pointerup', up as EventListener);
        document.addEventListener('pointercancel', up as EventListener);

        this.removeListeners = () => {
            document.removeEventListener('pointermove', move as EventListener);
            document.removeEventListener('pointerup', up as EventListener);
            document.removeEventListener('pointercancel', up as EventListener);
        };
    }

    private cleanup() {
        if (!this.dragging) return;
        this.dragging = false;
        this.pointerId = null;
        this.moved = false;
        this.schedule.onOffEndDrag();
        this.removeListeners?.();
        this.removeListeners = null;
    }

    subtitle(v: number) { return v ? this.subtitles.setSubtitle(v) : ''; }
    setIcon(v: number | MenuType) { return v === null ? '' : this.icon.setIcon(v); }
    sortById(a: MenuElement, b: MenuElement) { return a.id - b.id; }
}